export const getCachedTransferInfo = (id) => {
  if (!id) return null;
  try {
    const raw = sessionStorage.getItem(`payloft_transfer_info_${id}`);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed?.data) return parsed;
    }
  } catch (e) {
    console.error("Error reading transfer cache", e);
  }
  return null;
};

export const setCachedTransferInfo = (id, data) => {
  if (!id || !data) return;
  try {
    sessionStorage.setItem(`payloft_transfer_info_${id}`, JSON.stringify(data));
  } catch (e) {
    console.error("Error writing transfer cache", e);
  }
};

export const getCachedTransferUrl = (id) => {
  if (!id) return null;
  try {
    return sessionStorage.getItem(`payloft_transfer_url_${id}`);
  } catch (e) {
    return null;
  }
};

export const setCachedTransferUrl = (id, url) => {
  if (!id || !url) return;
  try {
    sessionStorage.setItem(`payloft_transfer_url_${id}`, url);
  } catch (e) {}
};

export const clearTransferCache = (id) => {
  try {
    if (id) {
      sessionStorage.removeItem(`payloft_transfer_info_${id}`);
      sessionStorage.removeItem(`payloft_transfer_url_${id}`);
    } else {
      Object.keys(sessionStorage).forEach((key) => {
        if (key.startsWith("payloft_transfer_")) {
          sessionStorage.removeItem(key);
        }
      });
    }
  } catch (e) {}
};
